import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0ebce182")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("svg", {
    "aria-hidden": "true",
    class: _ctx.className
  }, [
    _createVNode("use", { "xlink:href": _ctx.iconName }, null, 8, ["xlink:href"])
  ], 2))
})